import { Link } from 'react-router-dom';

export default function PublicHeader() {
  return (
    <header className="cv-public-header">
      <nav className="cv-public-nav" aria-label="Public navigation">
        <Link to="/" className="cv-public-brand" aria-label="CounselVault home">
          <span className="cv-brand-mark" aria-hidden="true">CV</span>
          <span>CounselVault</span>
        </Link>
        <div className="cv-public-nav-actions">
          <Link to="/academy" className="cv-nav-link">Academy</Link>
          <Link to="/pricing" className="cv-nav-link">Pricing</Link>
          <Link to="/request-demo" className="cv-nav-link">Request a demo</Link>
          <Link to="/legal/security" className="cv-nav-link">Security</Link>
          <Link to="/login" className="cv-nav-link">Sign in</Link>
          <Link to="/register" className="cv-btn cv-btn-primary">Request access</Link>
        </div>
      </nav>
    </header>
  );
}
